export enum LEXOFFICE_TAX_TYPE {
  NET = 'net', // net = DE
  INTRA_COMMUNITY_SUPPLY = 'intraCommunitySupply', // intraCommunitySupply = EU
  THIRD_PARTY_COUNTRY_SERVICE = 'thirdPartyCountryService', // thirdPartyCountryService = other countries
}
